if (document.getElementsByClassName('filter-modal').length > 0) {
  import('../Components/Vanilla/FilterModalController');
}
if (document.getElementById('product-page__read-more')) {
  import('../Components/Vanilla/ReadMoreController');
}
if (
  document.getElementsByClassName('product-detail__purchase-wrapper').length >
    0 ||
  document.getElementsByClassName('product-detail__purchase-container').length >
    0
) {
  import('../Components/Vanilla/AddOrRemoveFromInput');
}
if (document.getElementById('scroll-to-products')) {
  import('../Components/Vanilla/ScrollToProducts');
}
if (document.getElementById('toggleMyPagesNavigation')) {
  import('../Components/Vanilla/ToggleMyPagesNavigation');
}
if (document.getElementsByClassName('product__wrapper').length > 0) {
  import('../Components/Vanilla/ObserveProductClickEvent');
}
